import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import store from "@two-ui/store";
import App from "./App.vue";
import router from "./router";
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
} from "@fortawesome/vue-fontawesome";
import "@two-ui/icons";
import directivesPermission from "@two-ui/directives/permission";

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);
const app = createApp(App);
app.component("font-awesome-icon", FontAwesomeIcon);
app.component("font-awesome-layers", FontAwesomeLayers);
app.use(router);

app.use(pinia);

app.directive("permissions", directivesPermission);

store.populateInitialState();

app.mount("#app");
